<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="12" r="3" stroke="var(--icon-color)" stroke-linejoin="round" />
    <circle cx="25" cy="12" r="3" stroke="var(--icon-color)" stroke-linejoin="round" />
    <circle cx="16" cy="7" r="4" stroke="var(--icon-color)" stroke-linejoin="round" />
    <path d="M16 14L20 19H17.5V27H14.5V19H12L16 14Z" stroke="var(--icon-color)" stroke-linejoin="round" />
    <path d="M7 17L10 21H8.5V27H5.5V21H4L7 17Z" stroke="var(--icon-color)" stroke-linejoin="round" />
    <path d="M25 17L28 21H26.5V27H23.5V21H22L25 17Z" stroke="var(--icon-color)" stroke-linejoin="round" />
</svg>
